import {useCreateChecklistDefinitionMutation} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {ApiError, useNavigate} from 'shared/web';

import {ChecklistForm} from '../../components/ChecklistForm';
import {toCreateChecklistDefinitionBody} from '../../utils/toChecklistDefinitionRequestBody';

export function Create() {
  const navigate = useNavigate();

  const [createChecklistDefinition, createChecklistDefinitionQuery] =
    useCreateChecklistDefinitionMutation();

  return (
    <SettingsTemplate
      header={{
        title: i18n.t('page.settings.generalChecklist.create'),
        breadcrumbs: [
          {
            label: i18n.t('page.generalSettings.labels.title'),
            isCurrentPage: true,
          },
          {
            label: i18n.t('page.settings.generalChecklist.title'),
            href: settingsRoutes.generalChecklist,
          },
        ],
      }}
      isCreating
      data-testid={testIds.settings.generalChecklistCreate('newTemplate')}
    >
      <ChecklistForm
        onSubmit={async (formData, _setErrors, _reset, blockerContext) => {
          await createChecklistDefinition({
            body: toCreateChecklistDefinitionBody(formData),
          })
            .unwrap()
            .then(() => {
              if (blockerContext?.wasSubmittedFromBlocker) {
                return;
              }
              navigate(settingsRoutes.generalChecklist);
            })
            .catch((e: ApiError) =>
              handleApiError(e, {signalApiError: blockerContext?.reportApiFailure})
            );
        }}
        isLoading={createChecklistDefinitionQuery.isLoading}
      />
    </SettingsTemplate>
  );
}
